<script>
	const Vue = require('vue');
	const _ = require('underscore');
	const config = require('core/config');
	const model = require('model/model');
	const utilities = require('utilities');
	const scrollManager = require('ui/core/scrollManager');
	const logger = require('utilities/logger');
	const uaParser = new (require('ua-parser-js'))();

	const studentLibraryUtilities = require('utilities/studentLibraryUtilities');
	const markArticleRead = studentLibraryUtilities.markArticleRead;
	const submitArticleNote = studentLibraryUtilities.submitArticleNote;
	const addFavorite = studentLibraryUtilities.addFavorite;
	const removeFavorite = studentLibraryUtilities.removeFavorite;
	const setActiveProduct = studentLibraryUtilities.setActiveProduct;

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const SL_TOOL_CLICK = analyticsUtilities.events.SL_TOOL_CLICK;
	const SL_HOME = analyticsUtilities.events.SL_HOME;
	const SL_FAVORITE = analyticsUtilities.events.SL_FAVORITE;
	const SL_ARTICLE_FINISH = analyticsUtilities.events.SL_ARTICLE_FINISH;
	const SL_LOG = analyticsUtilities.events.SL_LOG;

	const articleContentMixin = require('mixins/article-content');

	let isMobile = false;

	try {
		const deviceType = uaParser.getDevice().type;
		isMobile = deviceType === 'mobile' || deviceType === 'tablet';
	} catch (e) {
		logger.info("Couldn't detect device type");
	}

	module.exports = {
		mixins: [articleContentMixin],
		components: {
			'audio-player': require('components/audio-player.vue').default,
			'sentence-frame-icon': require('components/svg/sentence-frame-icon.vue').default,
			'bookmark-icon': require('components/svg/bookmark-icon.vue').default,
			'thumbtack-icon': require('components/svg/thumbtack-icon.vue').default,
			'heart-icon': require('components/svg/heart-icon.vue').default,
			'validated-textarea': require('components/validated-textarea.vue').default,
			'article-image': require('components/article-image.vue').default,
			'article-ebook': require('components/article-ebook.vue').default,
			'load-mask': require('components/load-mask.vue').default,
			'vocab-popup-content-wrapper': require('components/vocab-popup-content-wrapper.vue').default,
			'sentence-frame': require('components/sentence-frame.vue').default
		},
		props: ['loading'],
		modelData: ['productId', 'activeProduct', 'libraryProducts', 'userContext', 'activeClass', 'libraryView'],
		data() {
			return {
				fontIndex: 0,
				paragraphsNumbered: false,
				showSentenceFrame: false,
				audioPinned: false,
				noteContent: '',
				internalLoading: false,
				isMobile
			};
		},
		methods: {
			nextFont() {
				this.fontIndex++;

				const action_type = 'font_size';
				const value = ['n', 'm', 'l', 'xl'][this.fontIndex % 4];

				fireEvent(SL_TOOL_CLICK, {
					action_type,
					value
				});
			},
			toggleParagraphNumbers() {
				this.paragraphsNumbered = !this.paragraphsNumbered;
				let action_type = 'show_paragraph_numbers';
				fireEvent(SL_TOOL_CLICK, {
					action_type,
					value: this.paragraphsNumbered
				});
			},
			toggleSentenceFrame() {
				this.showSentenceFrame = !this.showSentenceFrame;
				let action_type = 'show_sentence_frame';
				fireEvent(SL_TOOL_CLICK, {
					action_type,
					value: this.showSentenceFrame
				});
			},
			doneReading() {
				let product = this.product;
				let p = product.id;
				let uuid = this.uuid;
				let n = this.noteContent ? this.noteContent : undefined;
				let prms = markArticleRead(p, this.grade);

				this.internalLoading = true;
				if (n) {
					prms.then(() => submitArticleNote(p, n));
				}

				fireEvent(SL_ARTICLE_FINISH, {
					pid: uuid,
					bookmark: product.readNext,
					note: n
				});

				prms.then(() => {
					utilities.openModal('#modal-library-submit');
					this.internalLoading = false;
				});
			},
			toggleAudioPin() {
				this.audioPinned = !this.audioPinned;
				let action_type = 'pin_audio';
				fireEvent(SL_TOOL_CLICK, {
					action_type,
					value: this.audioPinned
				});
			},
			onNoteChange(e) {
				let value = e.target.value;
				this.noteContent = value;
			},
			toggleFavorite() {
				let p = this.uuid;
				let prms = null;
				let product = this.product;
				let value = true;
				this.internalLoading = true;
				if (product.favorite) {
					value = false;
					prms = removeFavorite(p);
				} else {
					prms = addFavorite(p);
				}
				fireEvent(SL_FAVORITE, {
					pid: p,
					value,
					loc: 'dialog'
				});
				prms.finally(() => (this.internalLoading = false));
			},
			onHomeClick() {
				fireEvent(SL_HOME, {
					loc: 'dialog'
				});
			},
			onRereadClick() {
				fireEvent(SL_LOG, {
					loc: 'article'
				});
			}
		},
		computed: {
			viewLoading() {
				return this.loading || this.internalLoading;
			},
			mp3: function () {
				let product = this.activeProduct;
				var audio = product ? product.audio : '';

				if (audio) {
					var endpoint = (config.resources.media.cdn || config.resources.media.origin) + '/data/audio/';
					return endpoint + audio + '.mp3';
				}

				return '';
			},
			uuid() {
				let product = this.activeProduct;
				let uuid = this.productId;
				if (product && product.uuid) {
					uuid = product.uuid;
				} else {
					let parse = utilities.parseProductUUIDAndVersion(uuid);

					if (parse && parse.uuid) {
						uuid = parse.uuid;
					}
				}
				return uuid;
			},
			product() {
				let uuid = this.uuid;
				let activeProduct = this.activeProduct;
				let libraryProducts = this.libraryProducts;
				let libraryProduct = {};
				let prdt = null;

				if (libraryProducts && libraryProducts[uuid]) {
					libraryProduct = libraryProducts[uuid];
				}

				if (!this.viewLoading) {
					prdt = _.assign({}, activeProduct, libraryProduct);
					prdt.content = utilities.cleanVocabLinks(prdt.content);
				}

				return prdt;
			},
			language() {
				const product = this.product;

				return product && product.language;
			},
			isTeacher() {
				return this.userContext && !this.userContext.classCode;
			},
			grade() {
				let activeClass = this.activeClass;
				let g = activeClass ? activeClass.g || activeClass.grade : null;
				return g;
			},
			fontSizeClass() {
				return ['', '-font-m', '-font-l', '-font-xl'][this.fontIndex % 4];
			}
		},
		watch: {
			libraryView() {
				this.showSentenceFrame = false;
			}
		},
		mounted() {
			Vue.nextTick(() => {
				scrollManager(0, {
					priority: 0
				});
			});
			if (!this.activeProduct || this.activeProduct.uuid !== this.productId) {
				this.internalLoading = true;
				setActiveProduct(this.productId).then(() => (this.internalLoading = false));
			}
		},
		beforeDestroy() {
			this.destroyCaptionTTSPlayers();
			model.remove('activeProduct');
			model.remove('ebookPage');
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.library-content {
		position: relative;

		.article-audio {
			position: sticky;
			top: 0;
			z-index: 1;

			&.pinned {
				position: static;
			}
		}

		.library-content-inner {
			max-width: $max-width-inner;
		}

		.title-wrapper {
			display: flex;

			// align-items: center;
			.title {
				flex: 1;
			}

			.tools {
				// text-align: right;
				margin-top: 2rem;
			}
		}

		article {
			&.numbered-paragraphs p:before {
				top: 0rem;
			}
		}

		form.submit-form,
		.already-read {
			margin-top: 2rem;

			> * {
				margin-bottom: 1rem;
			}

			p {
				text-align: left;
			}

			.validated-textarea textarea {
				min-height: 8rem;
			}
		}

		#modal-library-submit {
			.submit-article-container {
				display: flex;
				align-items: center;

				.article-title-container {
					flex: 1;
					padding: 1rem;
					font-weight: bold;
					text-align: left;
				}
			}

			.favorite-toggle {
				color: $c-slate-dark;

				&:hover {
					color: $c-blue;

					svg {
						stroke: $c-red;
					}
				}

				.heart-icon.active {
					stroke: $c-red;
				}
			}
		}
	}

	.student-library.ebook .library-content {
		.library-content-inner {
			max-width: $max-width;

			div[data-spacer] {
				display: none;
			}

			.submit-form {
				max-width: $max-width-inner;
				margin: 2rem auto;
			}
		}
	}
</style>
<template>
	<sentence-frame
		class="library-content"
		:show="showSentenceFrame">
		<div class="library-content-inner wrapper">
			<load-mask v-if="viewLoading"></load-mask>
			<article-ebook
				v-if="libraryView === 'ebook'"
				:article="product">
			</article-ebook>
			<div
				v-show="libraryView === 'content'"
				class="title-wrapper">
				<div
					class="title"
					:class="fontSizeClass">
					<h1 v-if="product && product.title">{{ product.title }}</h1>
					<div v-if="product && product.authors && product.authors.length">by {{ product.authors.join(', ') }}</div>
				</div>
				<div class="tools">
					<button
						class="button -outline font-size-button"
						@click="nextFont"
						aria-label="Change font size">
						<i
							class="icon-font-size"
							aria-hidden="true"></i>
					</button>
					<button
						class="button -outline"
						@click="toggleParagraphNumbers"
						:class="{ '-active': paragraphsNumbered }"
						aria-label="Toggle paragraph numbers"
						:aria-pressed="`${paragraphsNumbered}`">
						<i
							class="fa-solid fa-paragraph"
							aria-hidden="true"></i>
					</button>
					<button
						v-if="!isMobile"
						@click="toggleSentenceFrame"
						class="button -outline"
						:class="{ '-active': showSentenceFrame }"
						aria-label="Toggle sentence frame"
						:aria-pressed="`${showSentenceFrame}`">
						<sentence-frame-icon></sentence-frame-icon>
					</button>
				</div>
			</div>
			<div
				v-show="libraryView === 'content' && mp3"
				class="article-audio"
				:class="{
					pinned: audioPinned
				}">
				<audio-player
					:event-data="{
						pid: productId
					}"
					:src="mp3"
					:show-speed-selector="true">
				</audio-player>
				<button
					class="button -outline audio-pin-button"
					@click="toggleAudioPin"
					v-tooltip="'Pin to top'"
					:class="{
						'-active': audioPinned
					}">
					<thumbtack-icon></thumbtack-icon>
				</button>
			</div>
			<article
				v-show="libraryView === 'content'"
				class="content-body"
				:class="[{ 'numbered-paragraphs': paragraphsNumbered }, fontSizeClass]">
				<vocab-popup-content-wrapper
					v-if="product && product.content"
					:article="product"
					:event-data="{ loc: 'library' }">
					<span v-html="product.content"></span>
				</vocab-popup-content-wrapper>
			</article>
			<form
				class="submit-form text-centered"
				v-if="product && !product.read"
				@submit.prevent="doneReading">
				<hr />
				<p>Are you finished reading? Add a note about this reading passage if you’d like:</p>
				<validated-textarea
					class="print-hidden"
					@change.native="onNoteChange"
					:value="noteContent"
					@input.native="noteContent = $event.target.value"
					:placeholder="'What did you find most interesting about this reading passage?'">
				</validated-textarea>
				<button
					class="button"
					:disabled="isTeacher"
					type="submit">
					I'm Done!
				</button>
			</form>
			<div
				class="already-read text-centered"
				v-if="product && product.read">
				<hr />
				<p>You already read this passage. Great job!</p>
				<a
					href="/student-library#!libraryView:reading-log/"
					@click="onRereadClick"
					class="button"
					>Go to your Reading Log</a
				>
			</div>
		</div>
		<modal
			ref="modal"
			id="modal-library-submit"
			:ok="false"
			:centered="true"
			:loading="viewLoading">
			<template slot="header-container">
				<h2>Nice Work!</h2>
			</template>
			<div
				slot="content"
				class="library-submit-modal-body">
				<div class="submit-article-container">
					<article-image
						:image-url="product && product.img"
						:alt-text="product && product.imgAlt"></article-image>
					<div class="article-title-container">
						<div>You've finished reading</div>
						<div>{{ product && product.title }}</div>
					</div>
				</div>
				<button
					@click="toggleFavorite"
					class="favorite-toggle button -link margin-top-medium">
					<heart-icon
						:class="{
							active: product && product.favorite
						}"></heart-icon>
					<template v-if="product && !product.favorite"> Want to favorite this passage? </template>
					<template v-if="product && product.favorite"> This passage is one of your favorites! </template>
				</button>
				<p>
					<a
						href="/student-library"
						data-modal-close
						@click="onHomeClick"
						class="button">
						Home
					</a>
				</p>
			</div>
		</modal>
	</sentence-frame>
</template>
